<template>
<v-container fluid class="page-wrap">
    <v-row>
      <v-col cols="12" class="text-center">
          <header-vue/>
      </v-col>

      <v-col
        class="mb-5"
        cols="12"
        md="12"
      >
            <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                <v-card-title class="page-title-row">
                    <div>
                        <div class="text-overline accent--text font-weight-bold">SETUP</div>
                        <div class="text-h6 font-weight-bold primary--text">Terms</div>
                        <div class="text-body-2 grey--text">Manage CURRENT Term, Past Terms and New Sessions</div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn outlined rounded color="primary" class="font-weight-bold text-none" @click="reset">
                        <v-icon left>mdi-plus</v-icon>
                        Add New Term
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" v-if="editBtn">
                            <div class="text-overline accent--text font-weight-bold">Update Term</div>
                        </v-col>
                        <!-- Create /Update Form -->
                        <v-col cols="12" v-if="newform">
                            <v-form v-model="valid" ref="form">
                                <v-container>
                                    <v-row>
                                        <v-col
                                        cols="12"
                                        md="4"
                                        >
                                            <v-select
                                                v-model="form.session_id"
                                                outlined
                                                :items="sessions"
                                                item-text="name"
                                                item-value="session_id"
                                                :rules="[v => !!v || 'Session is required']"
                                                label="Select Session"
                                                prepend-inner-icon="mdi-calendar-range"
                                                required
                                                :disabled="editBtn"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="4"
                                        >
                                            <v-select
                                                v-model="form.term"
                                                outlined
                                                :items="terms"
                                                item-text="name"
                                                item-value="id"
                                                :rules="[v => !!v || 'Term is required']"
                                                label="Select Current Term"
                                                prepend-inner-icon="mdi-numeric"
                                                required
                                                :disabled="editBtn"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="4"
                                        >
                                            <v-menu
                                                v-model="menu2"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="form.resumptiondate"
                                                        outlined
                                                        label="Select Next Term Resumption"
                                                        prepend-inner-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                v-model="form.resumptiondate"
                                                @input="menu2 = false"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="4"
                                        >
                                            <v-text-field
                                                outlined
                                                v-model="form.schooldays"
                                                label="Number of days in term"
                                                type="number"
                                                prepend-inner-icon="mdi-calendar-month-outline"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="8"
                                        >
                                            <v-textarea
                                            outlined
                                            rows="1"
                                            row-height="15"
                                            v-model="form.generalupdate"
                                            label="Info for Parents / General Update"
                                            prepend-inner-icon="mdi-bullhorn-outline"
                                            ></v-textarea>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="4"
                                        v-if="editBtn"
                                        >
                                            <v-checkbox
                                            v-model="form.current"
                                            label="Tick to make current term"
                                            required
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="12"
                                        >
                                        <v-btn :disabled="!valid" color="primary" rounded elevation="2"
                                        class="font-weight-bold text-none mr-3" @click="postRecord" v-if="!editBtn"
                                        >
                                            Create
                                            <v-icon right>mdi-plus</v-icon>
                                        </v-btn>
                                        <v-btn :disabled="!valid" color="primary" rounded elevation="2"
                                        class="font-weight-bold text-none mr-3" @click="updateRecord" v-else
                                        >
                                            Update
                                            <v-icon right>mdi-check</v-icon>
                                        </v-btn>
                                        <v-btn text color="secondary" class="text-none" @click="newform = false">
                                            <v-icon left>mdi-arrow-left</v-icon>
                                            Go Back
                                        </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-form>
                        </v-col>
                        <!-- Records -->
                        <v-col cols="12" v-else>
                            <v-alert
                                type="info"
                                dense
                                border="left"
                                text
                                color="orange"
                                >
                                <marquee>
                                    <span v-for="(info,i) in infos" :key="i" class="black--text mr-5">
                                    {{info.content}} | &nbsp;
                                    </span>
                                </marquee>
                            </v-alert>
                            <info-loader-2 v-if="fetchingContent"/>
                            <v-row class="mb-5" v-else>
                                <v-col cols="12" md="12">
                                    <v-card outlined class="rounded-lg">
                                        <v-card-title>
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                            v-model="search"
                                            append-icon="mdi-magnify"
                                            label="Search"
                                            single-line
                                            hide-details
                                            outlined
                                            dense
                                            class="search-field"
                                        ></v-text-field>
                                        </v-card-title>

                                        <v-data-table
                                        :headers="headers"
                                        :items="records"
                                        :search="search"
                                        group-by="session.session"
                                        group-desc
                                        class="elevation-0"
                                        :options="{
                                        itemsPerPage: 50
                                        }"
                                        dense
                                        >
                                        <template v-slot:group.header="{ group }">
                                            <tr>
                                                <td :colspan="headers.length">
                                                   <strong>Session:</strong> {{ group }}
                                                </td>
                                            </tr>
                                        </template>

                                            <template v-slot:item.current_term="{ item }">
                                                <v-chip v-if="item.current_term == true"
                                                    color="green"
                                                    dense
                                                    dark
                                                >
                                                    {{ item.current_term }}
                                                </v-chip>
                                            </template>

                                            <template v-slot:item.actions="{ item }">
                                                <v-btn @click="editRecord(item)" fab light x-small class="mr-2" elevation="1">
                                                    <v-icon
                                                        small
                                                    >
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn v-if="item.total_students_with_results == 0 && item.current_term == false"  @click="deleteRecord(item)" fab color="error" x-small elevation="1">
                                                    <v-icon
                                                        small
                                                    >
                                                        mdi-trash-can-outline
                                                    </v-icon>
                                                </v-btn>
                                            </template>

                                        </v-data-table>
                                    </v-card>
                                </v-col>
                                <!-- Archive -->
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HeaderVue from '../../components/Header.vue'
import axios from 'axios';
import InfoLoader2 from '../../components/InfoLoader2.vue';
  export default {
    name: 'Terms',
    components: {
        HeaderVue,
        InfoLoader2
    },
    mounted() {
       if (!this.authToken) {
            this.$router.push({name: 'Login'})
       }
       this.getSessions()
       this.getRecords()
    },
    data: () => ({
        authToken:sessionStorage.getItem('authToken') ?? null,
        school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
        newform: false,
        editBtn: false,
        form:{},
        sessions:[],
        terms: [
            {id:'1', name:'1st Term'},
            {id:'2', name:'2nd Term'},
            {id:'3', name:'3rd Term'},
        ],
        infos:[
            {content: 'You can always set a new term whenever your school moves to a NEW term by clicking the Add New Term button. However you should only select a new Session ONLY when your school has moved to a new session.'},
            {content: 'Switching Sessions when you are still in the same session can have some unpredictable consequence.'},
            {content: 'Switching to a New session removes your students from their current class and you will have to Promote them to a new class before they become visible again.'},
            {content: 'You DO NOT have to change a past term to a current term if your aim is to view results sheets for that past term. You can simply do that by going to the Menu and clicking on Result Sheets.'},
        ],
        menu2:false,
        valid: true,
        fetchingContent:true,
        search: '',
        headers: [
          { value: 'term', text: 'Term', sortable: false  },
          { value: 'session.session', text: 'Session',sortable: false },
          { value: 'current_term', text: 'Current Term',sortable: false },
          { value: 'schooldays', text: 'Days in Term', sortable: false  },
          { value: 'total_students_with_results', text: 'Students with results', sortable: false  },
          { value: 'resumptiondate', text: 'Resumption Date', sortable: false },
          { value: 'actions', text: 'Actions', sortable: false },
        ],
        records:[],
    }),
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
        ]
    },
    methods: {
        reset () {
            this.newform = true
            this.form = {}
        },
        getSessions () {
            axios.get(process.env.VUE_APP_BASEURL+'/sessions?school_id='+this.school.school_id,
            {
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
            })
            .then((response) => {
                this.sessions =  response.data.data
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
            });
        },
        getRecords () {
            axios.get(process.env.VUE_APP_BASEURL+'/parameters?school_id='+this.school.school_id,
            {
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
            })
            .then((response) => {
                this.records =  response.data.data
                this.fetchingContent = false;
            })
            .catch((error) => {
                if (error.response?.status == 401) {
                    localStorage.removeItem('authToken')
                }
                this.$toast.error(error.response ? error.response.data.message : 'APP is temporarily unavailable. Wait or Contact us!', {
                    timeout: 5000
                });
            })
            .finally(() => {
                this.fetchingContent = false;
            });
        },
        postRecord () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.post(process.env.VUE_APP_BASEURL+'/parameters?school_id='+this.school.school_id,this.form,
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                });
                localStorage.setItem('currentSession', response.data.data.session.session);
                localStorage.setItem('currentTerm', response.data.data.term);
                this.getRecords()
                this.newform = false
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
        editRecord (record){
            this.newform = true
            this.form.id = record.parameter_id
            this.form.session_id = record.session.session_id
            this.form.term = record.raw_untransformed.term
            this.form.schooldays = record.schooldays
            this.form.generalupdate = record.generalupdate
            this.form.current = record.current_term
            this.form.resumptiondate = record.raw_untransformed.resumptiondate
            this.editBtn = true
        },
        updateRecord () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.put(process.env.VUE_APP_BASEURL+'/parameters/'+this.form.id+'?school_id='+this.school.school_id,this.form,
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                });
                localStorage.setItem('currentSession', response.data.data.session.session);
                localStorage.setItem('currentTerm', response.data.data.term);
                this.getRecords()
                this.editBtn = false
                this.newform = false
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
        deleteRecord (record) {
            if(confirm("Do you really want to delete?")){
                let loader = this.$loading.show()
                axios.delete(process.env.VUE_APP_BASEURL+'/parameters/'+record.parameter_id+'?school_id='+this.school.school_id+'&confirm=DELETE',{
                    headers:
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
                })
                .then(response => {
                     this.$toast.success(response.data.message, {
                        timeout: 5000
                    });
                    this.getRecords()
                })
                .catch(error => {
                    this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                    });
                })
                .finally(() => {
                    loader.hide()
                });
            }
        }
    },
  }
</script>

<style scoped>
.search-field {
    max-width: 280px;
}
</style>
